import React from 'react';
import { connect } from 'react-redux';
import type { RootState, Dispatch } from '../../../app/store';
import styles from './MobilePayment.module.css';
import { useParams } from 'react-router-dom';
import loader from '../../../images/loading.gif';

function Thanks ({ getReceipt, receipt  }: any) {
  const { storeId, orderId } = useParams()
  const intervalRef = React.useRef<ReturnType<typeof setInterval> | null>(null)
  const loopNumber = receipt?.order?.loopNumber ?? 0

React.useEffect(() => {
  if (!storeId || !orderId) return

    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        getReceipt({ storeId, orderId })
      }, 3000)
    }

  return () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  };
}, [storeId, orderId, getReceipt])

React.useEffect(() => {
  if (loopNumber && loopNumber > 0 && intervalRef.current) {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }
}, [loopNumber]);

  return (
    <div className={styles.thanks}>
      <div className={styles.content}>
        <h1 className={styles.heading}>Tack för ditt köp!</h1>
        {receipt?.order?.loopNumber && receipt.order.loopNumber > 0 ? (
          <div>
            <p className={styles.orderLabel}>Ditt ordernummer</p>
            <span className={styles.orderNo}>{receipt?.order?.loopNumber}</span>
          </div>
        ) : <img src={loader} alt="laddningsikon" style={{ display: 'block', margin: '0 auto' }} />}
      </div>
    </div>
  );
}

function mapState (state: RootState) {
  return {
    receipt: state.order.receipt,
  };
}
function mapDispatch (dispatch: Dispatch) {
  return {
    getReceipt: dispatch.order.getReceipt,
  };
}

export default connect(mapState, mapDispatch)(Thanks);
